// extracted by mini-css-extract-plugin
export default {"menuWrapper":"Menu_menuWrapper__8dlPo","menuButton":"Menu_menuButton__VX2pA","menuList":"Menu_menuList__Sn5ja","menuListItem":"Menu_menuListItem__LQlw6"};